module.exports = __webpack_public_path__ + "img/zhth-1.aaf8c40d.png";